export const translationMap = new Map()

const KEY_STYLE = 'background:#1a1a2e;color:#f0a500;padding:1px 6px;border-radius:3px;font-family:monospace;font-size:0.85em;border:1px solid #f0a500;white-space:nowrap;cursor:pointer'
const COPIED_STYLE = 'background:#1a4a1a;color:#4caf50;padding:1px 6px;border-radius:3px;font-family:monospace;font-size:0.85em;border:1px solid #4caf50'

function annotate(root) {
  if (!root || !root.querySelectorAll) return

  root.querySelectorAll('[data-i18n-key]').forEach(el => {
    if (el._i18nOrig === undefined) el.removeAttribute('data-i18n-key')
  })

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT)
  let node
  while ((node = walker.nextNode())) {
    const tag = node.parentElement?.tagName
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'TEXTAREA') continue
    const text = node.textContent.trim()
    if (text && translationMap.has(text)) {
      node.parentElement.setAttribute('data-i18n-key', translationMap.get(text))
    }
  }
}

let rafId = null
function scheduleAnnotation() {
  if (rafId) return
  rafId = requestAnimationFrame(() => {
    annotate(document.body)
    rafId = null
  })
}

async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text)
  } catch {
    const ta = document.createElement('textarea')
    ta.value = text
    document.body.appendChild(ta)
    ta.select()
    document.execCommand('copy')
    document.body.removeChild(ta)
  }
}

export default {
  install(Vue) {
    if (localStorage.getItem('adminTraduction') !== 'true') return

    document.addEventListener('mouseenter', (e) => {
      const el = e.target.closest('[data-i18n-key]')
      if (!el || el._i18nOrig !== undefined) return
      el._i18nOrig = el.innerHTML
      el.innerHTML = `<span style="${KEY_STYLE}" title="Clic pour copier">${el.dataset.i18nKey}</span>`
    }, true)

    document.addEventListener('mouseleave', (e) => {
      let el = e.target.closest('[data-i18n-key]')
      if (!el) {
        // fallback : data-i18n-key a pu être supprimé pendant le hover
        let node = e.target
        while (node && node !== document.body) {
          if (node._i18nOrig !== undefined) { el = node; break }
          node = node.parentElement
        }
      }
      if (!el || el._i18nOrig === undefined) return
      if (el.contains(e.relatedTarget)) return
      el.innerHTML = el._i18nOrig
      delete el._i18nOrig
    }, true)

    document.addEventListener('click', async (e) => {
      const el = e.target.closest('[data-i18n-key]')
      if (!el) return
      e.stopPropagation()
      const key = el.dataset.i18nKey
      const orig = el._i18nOrig
      await copyToClipboard(key)
      delete el._i18nOrig
      el.innerHTML = `<span style="${COPIED_STYLE}">✓ Copié !</span>`
      setTimeout(() => { el.innerHTML = orig }, 1200)
    })

    Vue.mixin({
      mounted: scheduleAnnotation,
      updated: scheduleAnnotation,
    })
  }
}
